// extracted by mini-css-extract-plugin
export default {"tags":"XfnLY8","dropdown":"A09iPT","tag":"R9NwSW","label":"u3qiQw","active":"G1Z10l"};